import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/BotonPSE.png'


const _withScopeId = n => (_pushScopeId("data-v-21c15bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col bg-white shadow-md p-4 my-2 rounded-lg" }
const _hoisted_2 = { class: "flex justify-between items-center pb-4 border-b md:flex-row md:justify-between md:items-center" }
const _hoisted_3 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_4 = { class: "font-normal" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "text-xs inline-block font-bold text-primary md:text-sm" }
const _hoisted_7 = { class: "py-4 border-b" }
const _hoisted_8 = { class: "accordion-section" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "transition ease duration-500" }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_14 = {
  key: 0,
  class: "text-xs text-left text-gris120 md:text-sm"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 9l-7 7-7-7"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["if"]
const _hoisted_18 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_19 = { class: "font-bold text-secondary mb-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary text-sm" }, "Comercio:", -1))
const _hoisted_21 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "Portafolio", -1))
const _hoisted_23 = { class: "text-sm text-gris120" }
const _hoisted_24 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "N° Crédito", -1))
const _hoisted_26 = { class: "text-sm text-gris120" }
const _hoisted_27 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary font-bold mb-1" }, "Capital", -1))
const _hoisted_29 = { class: "text-sm text-gris120" }
const _hoisted_30 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary font-bold mb-1" }, "Interés", -1))
const _hoisted_32 = { class: "text-sm text-gris120" }
const _hoisted_33 = { class: "flex-1 mt-2 text-sm md:mt-0 w-full md:w-1/6" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-primary mb-1" }, "Total Crédito", -1))
const _hoisted_35 = { class: "text-sm text-gris120" }
const _hoisted_36 = { class: "flex flex-col justify-between md:items-center md:flex-row mt-3 p-2 rounded bg-lightSurface-50" }
const _hoisted_37 = { class: "text-left" }
const _hoisted_38 = { class: "text-sm font-bold text-primary" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = {
  key: 0,
  class: "text-sm text-left font-bold text-gris80"
}
const _hoisted_41 = {
  key: 1,
  class: "text-sm text-left font-bold text-gris80"
}
const _hoisted_42 = { class: "text-left" }
const _hoisted_43 = { class: "text-sm font-bold text-primary" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_46 = { class: "text-left" }
const _hoisted_47 = { class: "text-sm font-bold text-primary" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Estado último pago"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_52 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_53 = { class: "flex flex-col justify-between md:items-center md:flex-row md:justify-end pt-4" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Transacción pendiente"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_57 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pse",
  class: "btn-pse"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Tooltips = _resolveComponent("Tooltips")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.negotiations, (negotiation) => {
    return (_openBlock(), _createElementBlock("div", {
      key: negotiation?.register_type_id
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(" Fecha de obligación: "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.formatDate(negotiation.created_at)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(negotiation.register_type_state), 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.bindClassState(negotiation.register_type_state))
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "acordeon-header",
              onClick: ($event: any) => (_ctx.toggleAccordion(negotiation.register_type_id))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "obligations__card-img",
                    src: negotiation?.url_logo,
                    alt: negotiation?.url_logo
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_13, " Negociación # " + _toDisplayString(negotiation.register_type === 'ObligacionActiva'
                        ? negotiation.identification
                        : negotiation.register_type_id), 1),
                    (negotiation?.notes != '')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(negotiation?.notes), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["acordeon-chevron", { '-rotate-180': _ctx.isOpen(negotiation.register_type_id) }])
                }, _hoisted_16, 2)
              ])
            ], 8, _hoisted_9),
            _createElementVNode("div", {
              class: _normalizeClass(["acordeon-body bg-lightSurface-50 rounded mt-2", 
              _ctx.isOpen(negotiation.register_type_id) ? 'max-h-screen' : 'max-h-0'
            ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(negotiation.business, (business) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col text-left w-full px-0 py-3 md:flex-row",
                  key: business.business_id,
                  if: business.negotiable === 1
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(business?.product), 1),
                    _createElementVNode("p", null, [
                      _hoisted_20,
                      _createTextVNode(" " + _toDisplayString(business?.commerce), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("p", _hoisted_23, _toDisplayString(business?.portfolio_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.hiddenPartialData(business?.credit)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$filters.currency(business.capital_value)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$filters.currency(business?.interests)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$filters.currency(business?.current_debt_value)), 1)
                  ])
                ], 8, _hoisted_17))
              }), 128))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, [
                _createTextVNode(_toDisplayString(negotiation.register_type === 'ObligacionActiva'
                  ? 'Saldo deuda'
                  : 'Pago mínimo'), 1),
                _hoisted_39
              ]),
              (
                negotiation.payment_information[0].sub_register_type != 'Total'
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$filters.currency(negotiation.payment_information[0].value)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$filters.currency(negotiation.payment_information[0].value)), 1))
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, [
                _createTextVNode(_toDisplayString(negotiation.register_type === 'ObligacionActiva'
                  ? 'Fecha límite pago'
                  : 'Fecha límite pago mínimo'), 1),
                _hoisted_44
              ]),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$filters.formatDate(
                  negotiation.payment_information[0].limit_date_payment
                )), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("span", _hoisted_47, [
                _createTextVNode(_toDisplayString(negotiation.register_type === 'ObligacionActiva'
                  ? 'Cédula cliente'
                  : 'Número de negociación') + " ", 1),
                _hoisted_48
              ]),
              _createElementVNode("span", _hoisted_49, _toDisplayString(negotiation.register_type === 'ObligacionActiva'
                  ? negotiation.identification
                  : negotiation.register_type_id), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("span", _hoisted_52, [
                _createVNode(_component_Loader, {
                  class: "inline-block align-text-top",
                  showLoader: _ctx.isLoadingPaymentStatus,
                  styles: 'relative size-xs'
                }, null, 8, ["showLoader"]),
                _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.getLastPaymentStatus(_ctx.getReference(negotiation))), 513), [
                  [_vShow, !_ctx.isLoadingPaymentStatus]
                ]),
                _createTextVNode(" - " + _toDisplayString(_ctx.getReference(negotiation)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_Tooltips, { title: "Aquí puede ver más información sobre su negociación" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.viewDetailPlan(negotiation, _ctx.obligationType)),
                class: "w-full px-4 py-2 mt-3 md:mt-0 text-sm text-white rounded-lg mr-3 bg-secondary border md:w-auto md:text-sm h-10"
              }, " Más información ", 8, _hoisted_54)
            ]),
            _: 2
          }, 1024),
          (!_ctx.canMakePayment(_ctx.getReference(negotiation)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.getReference(negotiation)), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.isLoadingPaymentStatus)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.makePayment(negotiation)),
                      class: "w-full px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success md:w-64 md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10"
                    }, [
                      _hoisted_59,
                      _createTextVNode(" Realizar pago mínimo ")
                    ], 8, _hoisted_58))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ]))
  }), 128))
}